import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../service/auth.service';

@Component({
  selector: 'app-signup',
  templateUrl: './signup.component.html',
  styleUrls: ['./signup.component.css']
})
export class SignupComponent {
  firstName: string = '';
  lastName: string = '';
  email: string = '';
  username: string = '';
  role: string = 'USER';
  password: string = '';
  confirmPassword: string = '';
  errorMessage: string = '';
  successMessage: string = '';
  isLoading: boolean = false;
  showPassword: boolean = false;
  showConfirmPassword: boolean = false;
  registrationComplete: boolean = false;

  // Password complexity validation
  passwordRequirements = {
    minLength: false,
    hasUppercase: false,
    hasLowercase: false,
    hasNumber: false,
    hasSpecialChar: false
  };

  constructor(
    private authService: AuthService,
    private router: Router
  ) {}

  // Check password complexity
  checkPasswordComplexity(): void {
    const password = this.password;
    this.passwordRequirements = {
      minLength: password.length >= 8,
      hasUppercase: /[A-Z]/.test(password),
      hasLowercase: /[a-z]/.test(password),
      hasNumber: /\d/.test(password),
      hasSpecialChar: /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/.test(password)
    };
  }

  // Check if password meets all requirements
  isPasswordValid(): boolean {
    return Object.values(this.passwordRequirements).every(req => req === true);
  }

  // Get password strength percentage
  getPasswordStrength(): number {
    const requirements = Object.values(this.passwordRequirements);
    const metRequirements = requirements.filter(req => req).length;
    return (metRequirements / requirements.length) * 100;
  }

  // Get password strength color
  getPasswordStrengthColor(): string {
    const strength = this.getPasswordStrength();
    if (strength <= 25) return '#dc2626'; // Red
    if (strength <= 50) return '#f59e0b'; // Orange
    if (strength <= 75) return '#10b981'; // Green
    return '#059669'; // Dark Green
  }

  onSubmit(): void {
    if (this.password !== this.confirmPassword) {
      this.errorMessage = 'Les mots de passe ne correspondent pas';
      return;
    }

    if (!this.isPasswordValid()) {
      this.errorMessage = 'Le mot de passe ne respecte pas les exigences de complexité';
      return;
    }

    this.isLoading = true;
    this.errorMessage = '';
    this.successMessage = '';

    const signupData = {
      firstName: this.firstName,
      lastName: this.lastName,
      email: this.email,
      username: this.username,
      password: this.password,
      role: this.role
    };

    this.authService.signup(signupData).subscribe({
      next: (response) => {
        this.registrationComplete = true;
        this.successMessage = response.message || 'Registration successful! Please check your email to verify your account.';
        this.isLoading = false;
      },
      error: (error) => {
        this.errorMessage = error.message || 'Registration failed. Please try again.';
        this.isLoading = false;
      }
    });
  }

  goToLogin(): void {
    this.router.navigate(['/login']);
  }
} 